export default defineNuxtPlugin((nuxtApp) => {
  let backupStorage = {};
  let storageMode = 'localStorage';
  try {
    void localStorage.length;
  } catch {
    try {
      void sessionStorage.length;
      storageMode = 'sessionStorage';
    } catch {
      storageMode = 'backupStorage';
    }
  }

  const storage = {
    setItem(key, value) {
      switch (storageMode) {
        case 'localStorage':
          localStorage.setItem(key, value);
          break;
        case 'sessionStorage':
          sessionStorage.setItem(key, value);
          break;
        case 'backupStorage':
          backupStorage[key] = value;
          break;
      }
    },
    getItem(key) {
      switch (storageMode) {
        case 'localStorage':
          return localStorage.getItem(key);
        case 'sessionStorage':
          return sessionStorage.getItem(key);
        case 'backupStorage':
          return backupStorage[key];
      }
    },
    removeItem(key) {
      switch (storageMode) {
        case 'localStorage':
          localStorage.removeItem(key);
          break;
        case 'sessionStorage':
          sessionStorage.removeItem(key);
          break;
        case 'backupStorage':
          delete backupStorage[key];
          break;
      }
    },
    clear() {
      switch (storageMode) {
        case 'localStorage':
          localStorage.clear();
          break;
        case 'sessionStorage':
          sessionStorage.clear();
          break;
        case 'backupStorage':
          backupStorage = {};
          break;
      }
    },
  };

  nuxtApp.provide('localStorage', storage);
});
